/**
 * Open a docked side panel tab (or focus it if already open).
 */
export const OPEN_SIDE_PANEL_TAB = 'OPEN_SIDE_PANEL_TAB';
/**
 * Remove a tab from docked and floating lists.
 */
export const REMOVE_SIDE_PANEL_TAB = 'REMOVE_SIDE_PANEL_TAB';
/**
 * Set the active docked tab.
 */
export const SET_ACTIVE_SIDE_PANEL_TAB = 'SET_ACTIVE_SIDE_PANEL_TAB';
/**
 * Close all docked and floating side panel apps.
 */
export const CLOSE_ALL_SIDE_PANELS = 'CLOSE_ALL_SIDE_PANELS';
/**
 * Pop a docked tab out into a floating window.
 */
export const POP_OUT_SIDE_PANEL_TAB = 'POP_OUT_SIDE_PANEL_TAB';
/**
 * Dock a floating tab back into the side panel.
 */
export const DOCK_SIDE_PANEL_TAB = 'DOCK_SIDE_PANEL_TAB';
/**
 * Update floating window geometry.
 */
export const SET_FLOATING_SIDE_PANEL_GEOMETRY = 'SET_FLOATING_SIDE_PANEL_GEOMETRY';
/**
 * Bring a floating window to the front.
 */
export const BRING_FLOATING_SIDE_PANEL_TO_FRONT = 'BRING_FLOATING_SIDE_PANEL_TO_FRONT';
/**
 * Set the docked side panel width.
 */
export const SET_SIDE_PANEL_WIDTH = 'SET_SIDE_PANEL_WIDTH';
/**
 * Set user-preferred docked side panel width.
 */
export const SET_USER_SIDE_PANEL_WIDTH = 'SET_USER_SIDE_PANEL_WIDTH';
/**
 * Whether the user is resizing the docked side panel.
 */
export const SET_SIDE_PANEL_IS_RESIZING = 'SET_SIDE_PANEL_IS_RESIZING';
